module.exports = __webpack_public_path__ + "img/toggle-on-solid.1404173d.svg";